<template>
  <div class="product">
    <div class="top">
      <img :src="$apiBaseUrl+top" style="width: 100%;height: 450px">
    </div>
    <div class="con_data">
      <h1 class="center blue">产品中心</h1>

      <Menu :list="CateName" @menuClick="isShow"></Menu><!--二级导航-->

      <div class="pro_info">
        <div class="lump" v-for="(item,index) in ImgData" :key="index">
          <router-link :to="{path:'/proDetails',query:{Id:item.Id}}"><img :src="$apiBaseUrl+item.ProductImg" width="270" height="270"></router-link>
          <h4 class="center mar0">{{item.ProductName}}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/menu'
export default {
  name: "company",
  components:{Menu},
  data(){
    return {
      top:'',//banner
      CateName:[],//导航信息
      Id:'',//获取图片id
      ImgData:[],
    }
  },
  mounted() {
    this.getTop()
    this.getNav()
  },
  methods:{
    getTop(){
      let data={params:{ImgCate:11}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取导航
    getNav(){
      let data={params:{ParentId:3}}
      this.$axios.get('/api/Byt_Ent_Gateway/Byt_ent_categorySelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.CateName = res.data;
        this.getImg(res.data[0].Id);
      })
    },
    //导航数据
    isShow(index,item){
      this.getImg(item.Id)
    },
    //获取图片
    getImg(id){
      let data = {params:{ProductCate:id}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntProductSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.ImgData = res.data;
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>
.pro_info{
  clear: both;
}
.lump{
  width: 230px;
  float: left;
  margin-right: 30px;
  padding:20px;
}
.lump:nth-child(4n){
  margin-right: 0;
}
.pages{
  clear: both;
  margin:20px 0;
}
</style>